import type { PlayerRetentionHomeSummary } from "@/types/services/api-contracts";

import { callEdgeData } from "./_core/edge-call";
import { RETENTION_FUNCTION_NAME } from "./_core/function-names";

export const retentionService = {
  async getPlayerHomeState(): Promise<PlayerRetentionHomeSummary> {
    return callEdgeData<PlayerRetentionHomeSummary>(RETENTION_FUNCTION_NAME, "player-home-state", {
      method: "GET",
    });
  },
};
